import { Injectable } from '@angular/core';
import { SystemPropertiesService } from '@app/core/services/system-properties.service';
import { Observable } from 'rxjs';
import { IExternalPdfFile, IFundExternalFilePayload, IFundTearsheet, IFundTearsheetCompany }  from '@common/models/IFundTearsheet'
import { ApiService } from '@app/core/services/api.service';
import { HttpHeaders } from '@angular/common/http';
import { IApiStatus } from '@common/models/IApiStatus';
import { ITearSheet, ITearsheetGeneratorPDF, ITearsheetJobStatus } from '@common/models/ITearSheet';
import { SpinnerService } from '@app/services/common/SpinnerService';

@Injectable({
  providedIn: 'root'
})

export class TearsheetPackageService {
  constructor(private readonly systemPropertiesService: SystemPropertiesService, private readonly apiService: ApiService,
    private readonly spinnerService: SpinnerService
  ) { }
    public getAvailableQuarters(){
      let quarters:any[] = [];
      this.systemPropertiesService.getByKey<string[]>('default.tearsheetpackage.quarters').subscribe((res) => {
        quarters = [...res]
      });
      return quarters.length>0? quarters: [];
    }
  saveFundTearsheet(fundName, quarter, requestBody): Observable<IFundTearsheet>{
    return this.apiService.put(`FundCapitalMember/TearsheetPackage/${fundName}/${quarter}`, requestBody)

  }
  getFundTearsheet(fundName: string, quarter: string): Observable<IFundTearsheet | IApiStatus>{
    return this.apiService.get(`FundCapitalMember/TearsheetPackage/${fundName}/${quarter}`)
  }
  public generateTearsheetPackageByQuarter(fund: string, quarter: string): Observable<{ fundName: string; base64: string }[]> {
    const url = `FundCapitalMember/TearsheetPackage/${fund}/${quarter}/generate`;
    return this.apiService.post(url, {}, {
      headers: new HttpHeaders({ 'Accept': 'application/json' }),
      responseType: 'json',
    }) as Observable<{ fundName: string; base64: string }[]>;
  }

  public previewDisclaimerTearsheetByQuarter(fund: string, quarter: string, updatedData: any): Observable<ITearsheetGeneratorPDF> {
    const url = `FundCapitalMember/TearsheetPackage/${fund}/${quarter}/previewDisclaimer`;
    return this.apiService.post(url, updatedData, {responseType: 'json' }) as Observable<ITearsheetGeneratorPDF>;
  }
  public downloadTearsheetPackageByQuarter(fund: string, quarter: string):  Observable<any> {
    const url = `FundCapitalMember/TearsheetPackage/${fund}/${quarter}/download`;
     return this.apiService.post(url, {}, {
            headers: new HttpHeaders().set('Accept', "application/pdf"),
            responseType: 'blob' as 'json',
            observe: 'response',
        });
  }
  bulkUpsertAndGenerate(
    fundNames: string[],
    quarter: string,
    updates: Partial<IFundTearsheetCompany>[],
    isGenerate: boolean)
    {
      const url = `FundCapitalMember/TearsheetPackage/bulkUpsertAndGenerate`;
      return this.apiService.post(url, {
      fundNames,
      quarter,
      updates,
      isGenerate
    });
  }
   public downloadLiveTearsheetPackage(mnemonic:string, fund: string, quarter: string, data: ITearSheet):  Observable<any> {
    const url = `FundCapitalMember/TearsheetPackage/${mnemonic}/${encodeURIComponent(fund)}/${quarter}/download-live`;
      return this.apiService.post(`${url}`,
          data,
          { responseType: 'arraybuffer' }
      );
  }
  saveExternalFilesMulti(payload: IFundExternalFilePayload): Observable<any> {
    const formData = new FormData();

    // Extract JSON without the file object
    const jsonPayload = {
      quarter: payload.quarter,
      deleteFiles: payload.deleteFiles,
      fundsFile: payload.fundsFile.map(f => ({
        positionKey: f.positionKey,
        fundNames: f.fundNames
      }))
    };

    // Append JSON
    formData.append("metaData", JSON.stringify(jsonPayload));

    // Append files
    payload.fundsFile.forEach((f) => {
      formData.append("uploads[]", f.file, f.file.name); // multiple files allowed
    });
    return this.apiService.post(`FundCapitalMember/TearsheetPackage/external-pdf`, formData);
  }

  public downloadExtPdf(path: string, fileName: string): Promise<File> {
    const promise = new Promise<File>((resolve, reject) => {   
      const url = `FundCapitalMember/TearsheetPackage/external-pdf-download`;
      this.spinnerService.skipSpinnerForURL = url;
      this.apiService.post(url, { path },  { responseType: 'arraybuffer' }).subscribe({
         next: (res) => {
          if (res) {
            // Buffer to file convert
            const blob = new Blob([res], { type: 'application/pdf' });
            const file = new File([blob], fileName, { type: 'application/pdf' });
            resolve(file);
          } else {
            reject(new Error('external pdf download error'));
          }
        },
        error: (error) => {
          reject(error?.message || 'external pdf download error');
         }
      }).add(() => this.spinnerService.skipSpinnerForURL = undefined);
    });

    return promise;
  }

  getExternalPdfLogs(quarter: string): Promise<IExternalPdfFile[]> {
    const promise = new Promise<IExternalPdfFile[]>((resolve, reject) => {
      const url = `FundCapitalMember/TearsheetPackage/logs/${quarter}`;
      return this.apiService.get(url).subscribe({
        next: (res: IExternalPdfFile[]) => {
          resolve(res)
        },
        error: (error) => {
          reject(error)
        }
      });
    });

    return promise;
  }

  getJobStatus(jobIds: string[]): Promise<ITearsheetJobStatus> {
    const promise = new Promise<ITearsheetJobStatus>((resolve, reject) => {
      const url = `FundCapitalMember/TearsheetPackage/job-status`;
      this.spinnerService.skipSpinnerForURL = url;
      return this.apiService.post(url, jobIds).subscribe({
        next: (res: ITearsheetJobStatus) => {
          resolve(res)
        },
        error: (error) => {
          reject(error)
        }
      }).add(() => this.spinnerService.skipSpinnerForURL = undefined);
    });

    return promise;
  }
}

